import React, { useState, useRef } from "react";
import { useQuery } from "react-query";
import { DataTable } from "primereact/datatable";
import authApi from "../../../service/IdApi";
import PageLoadError from "../../../components/PageLoadError";
import PageHeading from "../../../components/PageHeading";
import { Column } from "primereact/column";
import { Button } from 'primereact/button';
import { useAppContext } from "../../../context/appContext";
import { Dialog } from "primereact/dialog";
import CreditHistoryDialog from "./CreditHistoryDialogComp";
import AddCreditsDialog from "./AddCreditsDialogComp";
import { Menu } from 'primereact/menu';
import DataUtils from "../../../utils/DataUtils";

const FreeTrials = () => {
    const { switchUnclaimedProfile } = useAppContext();
    const [providers, setProviders] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const dataTable = useRef(null);
    const [showDetailsDialog, setShowDetailsDialog] = useState(false);
    const [showAddCreditsDialog, setShowAddCreditsDialog] = useState(false);
    const [subscriptionTableState, setSubscriptionTableState] = useState(() => {
        return {
            first: 0,
            rows: 25,
            page: 1,
            sortField: "trialStartAt",
            sortOrder: -1
        };
    });
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [users, setUsers] = useState([]);
    const [selectedProviderId, setSelectedProviderId] = useState(null); // State to store the selected provider ID
    const [isDialogVisible, setDialogVisible] = useState(false);
    const [rowActions, setRowActions] = useState([]);
    const menu = useRef(null);

    const { isLoading, isFetching, isError, data, refetch } = useQuery(["FreeTrials", subscriptionTableState], async () => {
        var body = {};
        body.first = subscriptionTableState.first;
        body.rows = subscriptionTableState.rows;
        body.sortField = subscriptionTableState.sortField;
        body.sortOrder = subscriptionTableState.sortOrder;
        body.status = ["trial"];
        const result = await authApi.post("admin/provider/search-subscriptions", body);
        setProviders(result.data.subscriptions);
        setTotalRecords(result.data.totalRecords);
        setLoaded(true);
        return data;
    });

    const pageHeader = (
        <PageHeading pageTitle="Admin - Free Trials">
            <div className="block">
            </div>
        </PageHeading>
    );

    if (isError) {
        return (
            <div>
                {pageHeader}
                <PageLoadError />
            </div>
        );
    }

    const onPage = (event) => {
        setSubscriptionTableState(event);
    };

    const onSort = (event) => {
        setSubscriptionTableState(event);
    };

    const exportCSV = (selectionOnly) => {
        dataTable.current.exportCSV({ selectionOnly });
    };

    const nameClicked = (e) => {
        e.preventDefault();
        switchUnclaimedProfile(selectedProvider.provider.name, selectedProvider.providerId, null);
    }

    const nameBodyTemplate = (rowData) => {
        return (
            <div className="">
                {rowData.provider && (
                    <a href="#" onClick={(e) => rowClicked(e, rowData)}>
                        {rowData.provider.name}
                    </a>
                )}
                {!rowData.provider && (
                    <span>[{rowData.providerId}]</span>
                )}
            </div>
        );
    };

    const creditsBodyTemplate = (rowData) => {
        var amount = "";
        if (rowData.credits) {
            amount = DataUtils.toUSCurrencyRounded(rowData.credits);
        }
        return (
            <span>{amount} </span>
        );
    }

    const rowClicked = async (e, rowData) => {
        e.preventDefault();
        setSelectedProvider(rowData);
        var body = {};
        body.providerId = rowData.providerId;
        const result = await authApi.post("admin/provider/users", body);
        setUsers(result.data.users);
        setShowDetailsDialog(true);
    }

    const hideDetailsDialog = () => {
        setShowDetailsDialog(false);
    }

    const emailBodyTemplate = (rowData) => {
        return (
            <div>
                <a href={`/account/admin/user-events?email=${rowData.email}`}>
                    {rowData.email}
                </a>
            </div>
        );
    }
    const handleShowDialog = (providerId) => {
        setSelectedProviderId(providerId);
        setDialogVisible(true);
    };

    const handleHideDialog = () => {
        setDialogVisible(false);
    };
   
    const showActionMenu = (e, rowData) => {

        const addCredits = {
            label: 'Add Credits',
            icon: 'pi pi-dollar',
            command: () => {
                setSelectedProviderId(rowData.providerId);
                setShowAddCreditsDialog(true);
            }
        };

        const viewCreditHistory = {
            label: 'View Credit History',
            icon: 'pi pi-history',
            command: () => {
                handleShowDialog(rowData.providerId);
            }
        };

        var _rowActions = []
        _rowActions.push(addCredits);
        _rowActions.push(viewCreditHistory);

        setRowActions(_rowActions);
        setSelectedProvider(rowData);
        menu.current.toggle(e);
    };
    
    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button
                    icon="pi pi-bars"
                    className="p-button-rounded p-button-icon-only p-button-text text-800"
                    onClick={(e) => showActionMenu(e, rowData)}
                    aria-controls="popup_menu"
                    aria-haspopup
                    tooltip="Profile Actions"
                    tooltipOptions={{ showDelay: 1000 }}
                />
            </div>
        );
    };

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                <div className="card pt-3 sm:pt-0">
                    <div className="flex py-3 w-full">
                        <div className="flex flex-row">
                        </div>
                        <div className="flex flex-row flex-grow-1 justify-content-end">
                            <Button type="button" icon="pi pi-file-export" rounded onClick={() => exportCSV(false)} data-pr-tooltip="CSV" label="Export" />
                        </div>
                    </div>
                    <Menu model={rowActions} popup ref={menu} className="white-space-nowrap" style={{ width: "325px" }} />
                    <DataTable
                        ref={dataTable}
                        value={providers}
                        dataKey="providerId"
                        paginator
                        rows={subscriptionTableState.rows}
                        rowsPerPageOptions={[25, 50, 100]}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} providers"
                        emptyMessage="No providers found."
                        lazy
                        first={subscriptionTableState.first}
                        totalRecords={totalRecords}
                        onPage={onPage}
                        onSort={onSort}
                        sortField={subscriptionTableState.sortField}
                        sortOrder={subscriptionTableState.sortOrder}
                        loading={isLoading || isFetching || !loaded}
                    >
                        <Column body={actionBodyTemplate} headerStyle={{ width: "1%", minWidth: "1rem" }}></Column>
                        <Column body={nameBodyTemplate} field="name" header="Name" sortable />
                        <Column header="Credits" body={creditsBodyTemplate} className="text-right" headerClassName="right-aligned-header" />
                        <Column field="trialStartAt" header="Trial Started On" sortable />
                        <Column field="trialEndAt" header="Trial Ends On" sortable />
                        
                    </DataTable>
                </div>
                <Dialog
                    visible={showDetailsDialog}
                    style={{ width: '50vw' }}
                    breakpoints={{ '1280px': '75vw', '641px': '95vw' }}
                    header="Free Trial Details"
                    modal
                    onHide={hideDetailsDialog}
                    className="p-fluid"
                >
                    {selectedProvider && (
                        <div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Name</label>
                                <div className="col">
                                    <a href="#" onClick={(e) => nameClicked(e)}>
                                        {selectedProvider.provider.name}<span className="ml-2 pi pi-arrow-right-arrow-left" style={{ fontSize: '.8rem' }} />
                                    </a>
                                </div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Provider ID</label>
                                <div className="col">{selectedProvider.providerId}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Provider Number</label>
                                <div className="col">{selectedProvider.provider.providerNumber}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Created On</label>
                                <div className="col">{selectedProvider.createdAt}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Trial Starts On</label>
                                <div className="col">{selectedProvider.trialStartAt}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Trial Ends On</label>
                                <div className="col">{selectedProvider.trialEndAt}</div>
                            </div>
                            {selectedProvider.provider && (
                                <>
                                    <div className="field grid mb-0">
                                        <label className="col-fixed" style={{ width: '150px' }}>City</label>
                                        <div className="col">{selectedProvider.provider.city}</div>
                                    </div>
                                    <div className="field grid mb-0">
                                        <label className="col-fixed" style={{ width: '150px' }}>State</label>
                                        <div className="col">{selectedProvider.provider.stateName}</div>
                                    </div>
                                    <div className="field grid mb-0">
                                        <label className="col-fixed" style={{ width: '150px' }}>Zip Code</label>
                                        <div className="col">{selectedProvider.provider.zipCode}</div>
                                    </div>
                                    <div className="field grid mb-0">
                                        <label className="col-fixed" style={{ width: '150px' }}>Country</label>
                                        <div className="col">{selectedProvider.provider.countryName}</div>
                                    </div>
                                    <div className="field grid mb-0">
                                        <label className="col-fixed" style={{ width: '150px' }}>Timezone</label>
                                        <div className="col">{selectedProvider.provider.timezone}</div>
                                    </div>
                                </>
                            )}
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Users</label>
                            </div>
                            <DataTable
                                value={users}
                                dataKey="userId"
                                className="datatable-responsive"
                            >
                                <Column field="userId" header="ID" sortable />
                                <Column field="email" body={emailBodyTemplate} header="Email" sortable />
                                <Column field="createdAt" header="Created On" sortable />
                            </DataTable>
                        </div>

                    )}
                </Dialog>
                
                <AddCreditsDialog
                    visible={showAddCreditsDialog}
                    onHide={() => setShowAddCreditsDialog(false)}
                    providerId={selectedProviderId}
                    refetch={refetch}
                />

                <CreditHistoryDialog
                    visible={isDialogVisible}
                    onHide={handleHideDialog}
                    providerId={selectedProviderId}
                />
            </div>
        </div>
    );
};

export default FreeTrials;
